<div class="flex items-center gap-x-2 mb-4">
	<label for="search" class="text-[12px]">Rechercher : </label>
	<input type="text" id="search" [(ngModel)]="searchTerm" (input)="onSearchChange()"
		class="placeholder:text-gray-300 text-[12px] rounded-lg border border-gray-300 w-[300px] p-2"
		placeholder="Rechercher un bénéficiaire..." />
</div>

<div *ngIf="loading">Chargement des bénéficiaires...</div>
<div *ngIf="error" class="text-red-500">{{ error }}</div>

<table *ngIf="!loading && !error && displayBeneficiaries.length > 0" class="min-w-full divide-y divide-gray-200">
	<thead class="bg-gray-50">
		<tr>
			<th class="px-4 py-2 text-left text-sm">Bénéficiaire</th>
			<th class="px-4 py-2 text-left text-sm">Sexe</th>
			<th class="px-4 py-2 text-left text-sm">Date de naissance</th>
			<th class="px-4 py-2 text-left text-sm">Téléphone</th>
			<th class="px-4 py-2 text-left text-sm">Type de bénéficiaire</th>
		</tr>
	</thead>
	<tbody>
		<ng-container *ngFor="let beneficiary of displayBeneficiaries; let i = index">
			<tr class="bg-white border-b border-gray-200">
				<td class="px-4 py-3 flex items-center gap-2">
					<button (click)="expandedIndex = expandedIndex === i ? null : i" class="focus:outline-none">
						<lucide-icon [img]="expandedIndex === i ? Minus : Plus" [size]="16"></lucide-icon>
					</button>
					<span class="font-semibold text-gray-800 text-sm">
						{{ beneficiary.userId.firstName }} {{ beneficiary.userId.lastName }}
					</span>
				</td>
				<td class="px-4 py-3">
					<span class="text-sm"
						[ngClass]="{'text-blue-600 font-bold': beneficiary.userId.sex === 'male', 'text-pink-500 font-bold': beneficiary.userId.sex === 'female'}">
						{{ beneficiary.userId.sex.substring(0, 1) | uppercase }}
					</span>
				</td>
				<td class="px-4 py-3 text-sm">{{ beneficiary.userId.birthday }}</td>
				<td class="px-4 py-3 text-sm">
					{{ beneficiary.userId.phoneNumbers && beneficiary.userId.phoneNumbers.length > 0 ?
					(beneficiary.userId.phoneNumbers[0].countryCode + beneficiary.userId.phoneNumbers[0].number | phoneNumber) :
					''
					}}
				</td>
				<td class="px-4 py-3 text-sm">
					{{ beneficiary.isPrincipalInsured ? 'Bénéficiaire Principal' : 'Ayant Droit' }}
				</td>
			</tr>
			<tr *ngIf="expandedIndex === i">
				<td colspan="5" class="p-4">
					<div class="flex gap-8">
						<img *ngIf="beneficiary.photo && beneficiary.photo.presignedUrl" [src]="beneficiary.photo.presignedUrl"
							alt="Photo du bénéficiaire" class="w-32 h-32 rounded mb-2" />
						<div class="flex-1">
							<table class="min-w-[300px] w-full">
								<thead>
									<tr>
										<th class="text-primary w-1/2 text-left p-3">Prestation</th>
										<th class="text-primary w-1/2 text-left p-3">Taux</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let prestation of getPrestationsToShow(beneficiary); let j = index"
										[ngClass]="j % 2 === 0 ? 'bg-slate-50' : 'bg-white'">
										<td class="text-sm p-3">
											{{ prestation.label }}
											<span *ngIf="prestation.medicalAct" class="text-xs text-red-500 ml-2">(Acte médical)</span>
										</td>
										<td class="text-sm p-3">{{ prestation.pourcentage }}%</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<button *ngIf="hasMedicalActPrestations(beneficiary)" (click)="toggleAllPrestations(beneficiary._id)"
						class="text-[12px] px-3 py-2 rounded bg-primary text-white m-4">
						{{ showAllPrestations[beneficiary._id] ? 'Masquer les actes médicaux' : 'Afficher tout' }}
					</button>
				</td>
			</tr>
		</ng-container>
	</tbody>
</table>
<div *ngIf="!loading && !error && displayBeneficiaries.length === 0">
	@if (searchTerm && searchTerm.trim() !== '') {
	Aucun bénéficiaire ne correspond à votre recherche "{{ searchTerm }}".
	} @else {
	Aucun bénéficiaire trouvé.
	}
</div>